/**
 * normalizeForSpeech — transform display text into a form the Web Speech API
 * will speak correctly.  Applied only at the speechSynthesis.speak() callsite;
 * the original text is never mutated so bubbles and stores are unaffected.
 *
 * Only used in "browser" TTS mode.  Kokoro handles these cases natively.
 */
export function normalizeForSpeech(text: string): string {
  return text
    // "6.5"  → "6 point 5"  (decimal numbers — period reads as a pause otherwise)
    .replace(/(\d+)\.(\d+)/g, "$1 point $2")
    // "+9"   → "plus 9"     (some voices skip the plus sign)
    .replace(/\+(\d)/g, "plus $1")
    // "15/14/15" → "15, 14, 15"  (slashes read as "slash" on some voices)
    .replace(/(\d+)\/(\d+)\/(\d+)/g, "$1, $2, $3")
    // "Lv 40" / "Lv. 40" → "Level 40"
    .replace(/\bLv\.?\s*(\d)/gi, "Level $1")
    // "#1,234" → "rank 1234"  (commas inside ranked numbers cause odd pauses)
    .replace(/#(\d[\d,]*)/g, (_, n) => "rank " + n.replace(/,/g, ""))
    // PvP move-stat abbreviations — TTS spells these as letters which is
    // hard to follow.  Expand to the full phrase.
    //   DPT  → Damage Per Turn
    //   EPT  → Energy Per Turn
    //   DPE  → Damage Per Energy
    //   DPS  → Damage Per Second
    .replace(/\bDPT\b/g, "Damage Per Turn")
    .replace(/\bEPT\b/g, "Energy Per Turn")
    .replace(/\bDPE\b/g, "Damage Per Energy")
    .replace(/\bDPS\b/g, "Damage Per Second")
    // "moveset(s)" → "move set(s)"  (TTS voices often mispronounce as one garbled word)
    .replace(/\bmoveset(s?)\b/gi, "move set$1");
}
